/**
 * User roles and permissions constants
 */

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  EXECUTIVE: 'executive',
  DEPARTMENT_MANAGER: 'department_manager',
  MANAGER: 'manager', // Alias for department_manager
  STAFF: 'staff',
  VIEWER: 'viewer',
};

export const PERMISSIONS = {
  // User Management
  USERS_VIEW: 'users.view',
  USERS_CREATE: 'users.create',
  USERS_EDIT: 'users.edit',
  USERS_DELETE: 'users.delete',
  
  // Inventory Management
  INVENTORY_VIEW: 'inventory.view',
  INVENTORY_CREATE: 'inventory.create',
  INVENTORY_EDIT: 'inventory.edit',
  INVENTORY_DELETE: 'inventory.delete',
  
  // Financial Management
  FINANCIAL_VIEW: 'financial.view',
  FINANCIAL_EDIT: 'financial.edit',
  REPORTS_VIEW: 'reports.view',
  REPORTS_CREATE: 'reports.create',
  
  // Budget Management
  BUDGET_VIEW: 'budget.view',
  BUDGET_EDIT: 'budget.edit',
  BUDGET_APPROVE: 'budget.approve',
  
  // Department Management
  DEPARTMENT_VIEW: 'department.view',
  DEPARTMENT_MANAGE: 'department.manage',
  
  // Tasks & Workflows
  TASKS_VIEW: 'tasks.view',
  TASKS_ASSIGN: 'tasks.assign',
  TASKS_MANAGE: 'tasks.manage',
};

// Role-based permission mapping
export const ROLE_PERMISSIONS = {
  [USER_ROLES.SUPER_ADMIN]: Object.values(PERMISSIONS), // All permissions
  
  [USER_ROLES.ADMIN]: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.USERS_CREATE,
    PERMISSIONS.USERS_EDIT,
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.INVENTORY_CREATE,
    PERMISSIONS.INVENTORY_EDIT,
    PERMISSIONS.FINANCIAL_VIEW,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.REPORTS_CREATE,
    PERMISSIONS.BUDGET_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.TASKS_VIEW,
    PERMISSIONS.TASKS_ASSIGN,
  ],
  
  [USER_ROLES.EXECUTIVE]: [
    PERMISSIONS.USERS_VIEW,
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.FINANCIAL_VIEW,
    PERMISSIONS.FINANCIAL_EDIT,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.REPORTS_CREATE,
    PERMISSIONS.BUDGET_VIEW,
    PERMISSIONS.BUDGET_APPROVE,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.TASKS_VIEW,
  ],
  
  [USER_ROLES.DEPARTMENT_MANAGER]: [
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.FINANCIAL_VIEW,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.BUDGET_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.DEPARTMENT_MANAGE,
    PERMISSIONS.TASKS_VIEW,
    PERMISSIONS.TASKS_ASSIGN,
    PERMISSIONS.TASKS_MANAGE,
  ],
  
  // Alias for manager role (same as department_manager)
  [USER_ROLES.MANAGER]: [
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.FINANCIAL_VIEW,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.BUDGET_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.DEPARTMENT_MANAGE,
    PERMISSIONS.TASKS_VIEW,
    PERMISSIONS.TASKS_ASSIGN,
    PERMISSIONS.TASKS_MANAGE,
  ],
  
  [USER_ROLES.STAFF]: [
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.TASKS_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
  ],
  
  [USER_ROLES.VIEWER]: [
    PERMISSIONS.INVENTORY_VIEW,
    PERMISSIONS.FINANCIAL_VIEW,
    PERMISSIONS.REPORTS_VIEW,
    PERMISSIONS.DEPARTMENT_VIEW,
    PERMISSIONS.TASKS_VIEW,
  ],
};
